import { Product, ProductComponent } from '../../types';
import { getComponentTotal } from './getComponentTotal';
import  Decimal  from 'decimal.js';

export function getComponentsTotal(product: Product, components: ProductComponent[]) : number {
    const componentTotals = product.components.reduce((acc, component) => acc.add(getComponentTotal(component, components)), new Decimal(0));
    return componentTotals.toNumber();
}